// src/components/typography/typography.type.ts
var typographyVariants = ["default", "primary", "secondary", "tertiary", "success", "neutral", "warning", "danger", "gray"];
var typographyVariantScales = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];
var typographyWeights = [100, 200, 300, 400, 500, 600, 700, 800, 900];
var typographyTypeCategoryMap = {
  heading: ["heading-xxx-small", "heading-xx-small", "heading-x-small", "heading-small", "heading-medium", "heading-large", "heading-x-large"],
  label: ["label-xx-small", "label-x-small", "label-small", "label-medium", "label-large"],
  paragraph: ["paragraph-x-small", "paragraph-small", "paragraph-medium", "paragraph-large"],
  display: ["display-small", "display-medium", "display-large"],
  table: ["table-data", "table-header"]
};
var typographyTypeTagNameMap = {
  "heading-xxx-small": "DIV",
  "heading-xx-small": "H6",
  "heading-x-small": "H5",
  "heading-small": "H4",
  "heading-medium": "H3",
  "heading-large": "H2",
  "heading-x-large": "H1",
  "label-xx-small": "LABEL",
  "label-x-small": "LABEL",
  "label-small": "LABEL",
  "label-medium": "LABEL",
  "label-large": "LABEL",
  "paragraph-x-small": "P",
  "paragraph-small": "P",
  "paragraph-medium": "P",
  "paragraph-large": "P",
  "display-small": "DIV",
  "display-medium": "DIV",
  "display-large": "DIV",
  "table-header": "SPAN",
  "table-data": "SPAN"
};

export {
  typographyVariants,
  typographyVariantScales,
  typographyWeights,
  typographyTypeCategoryMap,
  typographyTypeTagNameMap
};
